var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.159839 5.45946L0.487403 5.7893C0.590493 5.89231 0.727648 5.94906 0.874234 5.94906C1.02074 5.94906 1.15806 5.89231 1.26115 5.7893L4.99776 2.05252L8.73869 5.79345C8.84162 5.89646 8.97893 5.95312 9.12544 5.95312C9.27195 5.95312 9.40934 5.89646 9.51235 5.79345L9.84 5.46564C10.0533 5.25247 10.0533 4.90523 9.84 4.69206L5.38598 0.222022C5.28305 0.119094 5.1459 0.0465723 4.99809 0.0465722L4.99638 0.0465722C4.8498 0.0465722 4.71264 0.119175 4.60971 0.222022L0.159839 4.67994C0.0567485 4.78287 0.000163168 4.92417 7.71459e-08 5.07068C6.43309e-08 5.21726 0.0567484 5.35662 0.159839 5.45946Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.a9701dbba1d28aaac777b707b4c88432.svg";
export { ForwardRef as ReactComponent };